import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { SidebarBadgeValue } from '../types';

export const SidebarCounterBadge: React.FC<{ value: SidebarBadgeValue }> = ({ value }) => {
  const theme = useTheme();

  if (!value) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 16,
        width: 16,
        backgroundColor: theme.palette['brand pink'],
        borderRadius: '50%',
        color: theme.palette.white,
        mr: 1.25,
      }}
    >
      <Typography variant="extraSmall">{value}</Typography>
    </Box>
  );
};
